import { app } from "modular-openscriptjs";

const h = app("h");

export default function MentionSearchCanvas(...args) {
	return h.$(
		h.div(
			{ class: "offcanvas-body" },
			...args,
			h.div(
				{ class: "d-flex justify-content-end mt-2" },
				h.button({
					class: "btn-close",
					onclick: this.xMethod("MentionSearchForm.closeForm"),
				})
			)
		)
	);
}
